import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useMemo } from 'react';
import { FactionNameToId } from '../utils.js';
import { useUpdater } from '../../../hooks/use-updater.js';
var initialState = {
  loading: true,
  statusData: [],
  oldStatusData: []
};
var WarzoneStatusContext = createContext(initialState);
var WarzoneStatusProvider = function WarzoneStatusProvider(_ref) {
  var initialData = _ref.data,
    updateFunc = _ref.updateFunc,
    updateInterval = _ref.updateInterval,
    children = _ref.children;
  var _useUpdater = useUpdater(initialData, updateFunc, updateInterval),
    _useUpdater2 = _slicedToArray(_useUpdater, 3),
    statusData = _useUpdater2[0],
    oldStatusData = _useUpdater2[1],
    loading = _useUpdater2[2].loading;
  var value = {
    statusData: statusData,
    oldStatusData: oldStatusData,
    loading: loading
  };
  return /* @__PURE__ */jsx(WarzoneStatusContext.Provider, {
    value: value,
    children: children
  });
};
var findSystem = function findSystem(id, items) {
  return items.find(function (_ref2) {
    var solarsystemID = _ref2.solarsystemID;
    return id === solarsystemID;
  });
};
var useWarzoneStatus = function useWarzoneStatus() {
  return useContext(WarzoneStatusContext);
};
var useWarzoneSystemStatus = function useWarzoneSystemStatus(solarsystemId) {
  var _useWarzoneStatus = useWarzoneStatus(),
    statusData = _useWarzoneStatus.statusData,
    oldStatusData = _useWarzoneStatus.oldStatusData,
    loading = _useWarzoneStatus.loading;
  return useMemo(function () {
    if (solarsystemId === void 0 || loading) {
      return {
        status: void 0,
        previousStatus: void 0,
        active: false,
        found: false,
        loading: loading
      };
    }
    var status = findSystem(solarsystemId, statusData);
    var previousStatus = findSystem(solarsystemId, oldStatusData);
    if (status !== void 0 && previousStatus !== void 0) {
      return {
        status: status,
        previousStatus: previousStatus,
        active: status.contestedAmount > previousStatus.contestedAmount,
        found: true,
        loading: loading
      };
    }
    return {
      status: status,
      previousStatus: previousStatus,
      active: false,
      found: false,
      loading: loading
    };
  }, [statusData, oldStatusData, solarsystemId, loading]);
};
var useWarzoneFactionStatus = function useWarzoneFactionStatus(faction) {
  var _useWarzoneStatus2 = useWarzoneStatus(),
    statusData = _useWarzoneStatus2.statusData,
    loading = _useWarzoneStatus2.loading;
  return useMemo(function () {
    var id = FactionNameToId(faction);
    if (loading || !statusData) return null;
    return (statusData || []).filter(function (x) {
      return x.occupierFaction === id;
    });
  }, [statusData, loading, faction]);
};
export { WarzoneStatusProvider, useWarzoneFactionStatus, useWarzoneStatus, useWarzoneSystemStatus };